import {
  useEffect,
} from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';

import MainLoggedIn from './MainLoggedIn';
import AuthProvider from './stores/auth/AuthProvider';
import StatsProvider from './stores/stats/StatsProvider';
import TownAssetsProvider from './stores/townAssets/TownAssetsProvider';
import InviteAckPage from './views/InviteAck/InviteAckPage';
import RecoverPage from './views/Recover/RecoverPage';

const preloader = document.querySelector('.preloader');

function MainRoutes() {
  // Remove the initial loading wheel once React is up and running
  useEffect(
    () => {
      if (preloader) {
        preloader.classList.remove('preloader');
        preloader.classList.add('preloader-hide');
      }
    },
    [],
  );

  return (
    <Routes>

      <Route
        path="/recover"
        element={(
          <StatsProvider>
            <AuthProvider>
              <TownAssetsProvider public>
                <RecoverPage />
              </TownAssetsProvider>
            </AuthProvider>
          </StatsProvider>
        )}
      />

      <Route
        path="/invite"
        element={(
          <StatsProvider>
            <AuthProvider>
              <TownAssetsProvider public>
                <InviteAckPage />
              </TownAssetsProvider>
            </AuthProvider>
          </StatsProvider>
        )}
      />

      <Route
        path="*"
        element={<MainLoggedIn />}
      />
    </Routes>
  );
}

export default MainRoutes;
